import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-credit-card-02',
  imports: [],
  templateUrl: './credit-card-02.html',
  styleUrl: './credit-card-02.scss',
})
export class CreditCard02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
